import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Trophy, DollarSign, Star } from 'lucide-react';
const badges = [{
  icon: ShieldCheck,
  label: 'Compra 100% segura'
}, {
  icon: Trophy,
  label: 'Garantía de 7 días'
}, {
  icon: DollarSign,
  label: 'Reembolso garantizado'
}, {
  icon: Star,
  label: 'Calidad garantizada'
}];
export function Guarantee() {
  return <section className="py-24 bg-sand" data-id="element-200">
      <div className="max-w-5xl mx-auto px-6 lg:px-8" data-id="element-201">
        <motion.div className="bg-white rounded-3xl p-10 lg:p-14 shadow-sm border border-sand" initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-202">
          <div className="flex flex-col lg:flex-row gap-10 lg:gap-14 items-center" data-id="element-203">
            {/* Badge */}
            <motion.div className="shrink-0" initial={{
            opacity: 0,
            scale: 0.8
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.2,
            duration: 0.5
          }} data-id="element-204">
              <div className="relative w-40 h-40" data-id="element-205">
                {/* Outer ring */}
                <div className="absolute inset-0 rounded-full bg-olive shadow-lg" data-id="element-206" />
                <div className="absolute inset-[4px] rounded-full bg-olive border-2 border-cream/30" data-id="element-207" />
                <div className="absolute inset-[8px] rounded-full bg-olive border border-cream/20" data-id="element-208" />
                {/* Inner circle */}
                <div className="absolute inset-[12px] rounded-full bg-cream flex flex-col items-center justify-center text-center border-4 border-olive" data-id="element-209">
                  <span className="text-[10px] uppercase tracking-widest text-olive font-bold" data-id="element-210">
                    Garantía
                  </span>
                  <span className="text-4xl font-serif text-olive font-bold leading-none mt-1" data-id="element-211">
                    7
                  </span>
                  <span className="text-[10px] uppercase tracking-widest text-olive font-bold" data-id="element-212">
                    días
                  </span>
                </div>
                {/* Stars */}
                <div className="absolute -top-1 left-1/2 -translate-x-1/2 flex gap-1" data-id="element-213">
                  {[...Array(3)].map((_, i) => <Star key={i} className="w-3 h-3 fill-terracotta text-terracotta" data-id="element-214" />)}
                </div>
              </div>
            </motion.div>

            {/* Content */}
            <div className="flex-1 text-center lg:text-left" data-id="element-215">
              <motion.h2 className="text-3xl lg:text-4xl font-serif text-charcoal mb-6" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.1
            }} data-id="element-216">
                ¡Satisfacción garantizada y riesgo cero!
              </motion.h2>

              <motion.div className="space-y-4 text-warmGray leading-relaxed" initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: 0.2
            }} data-id="element-217">
                <p data-id="element-218">
                  Si compras la{' '}
                  <span className="font-bold text-charcoal" data-id="element-219">
                    Guía Primeros Bocados
                  </span>{' '}
                  y por cualquier motivo no quedas satisfecho/a, tienes{' '}
                  <span className="font-bold text-charcoal" data-id="element-220">
                    7 días completos
                  </span>{' '}
                  para solicitar un reembolso.
                </p>
                <p data-id="element-221">
                  Simplemente envíanos un correo electrónico a{' '}
                  <span className="font-medium text-charcoal" data-id="element-222">
                    epikkastore@gmail.com
                  </span>{' '}
                  y te reembolsaremos{' '}
                  <span className="font-bold text-charcoal" data-id="element-223">
                    el 100% de tu inversión
                  </span>
                  . ¡Incluso puedes quedarte con el producto!
                </p>
              </motion.div>
            </div>
          </div>

          {/* Trust badges */}
          <motion.div className="mt-10 pt-8 border-t border-sand grid grid-cols-2 md:grid-cols-4 gap-4" initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.4
        }} data-id="element-224">
            {badges.map((badge, i) => <div key={i} className="flex items-center justify-center gap-2 bg-cream border border-sand rounded-xl py-3 px-4" data-id="element-225">
                <badge.icon className="w-4 h-4 text-olive shrink-0" data-id="element-226" />
                <span className="text-sm font-medium text-charcoal" data-id="element-227">
                  {badge.label}
                </span>
              </div>)}
          </motion.div>
        </motion.div>
      </div>
    </section>;
}